import { CreateOrderType } from '@fd/common/biz/order';
import { useSession } from '@/context/session/useSession';
import { createCheckout } from '@/payment/createCheckout';
import usePaymentDetails from '@/store/paymentDetailsStore';
import { generateLoginAndPayUrl } from '@/utils/generateLoginAndPayUrl';
import { useState } from 'react';
import Flex from '@/components/ui/Flex';
import { ChevronRight, LoaderCircle } from 'lucide-react';
import useCart from '@/store/cartStore';
import clsx from 'clsx';
import { Button } from '@fd/frontend/components/ui/Button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@fd/frontend/components/ui/Tooltip';

export default function BuyButton() {
  const [isInProgress, setInProgress] = useState(false);
  const { session } = useSession();
  const { paymentMethod, coupon } = usePaymentDetails();
  const { items } = useCart();
  const isEmptyCart = !items.length;

  const handleCheckout = async () => {
    setInProgress(true);

    try {
      const mobileGb =
        items.find((item) => item.type === 'mobile')?.quantity || 0;
      const residentialGb =
        items.find((item) => item.type === 'residential')?.quantity || 0;
      const datacenterGb =
        items.find((item) => item.type === 'datacenter')?.quantity || 0;

      const orderParams: CreateOrderType = {
        gateway: paymentMethod,
        recurrent: true,
        mobileGb,
        residentialGb,
        datacenterGb,
        promocode: coupon?.code,
      };

      if (!session) {
        const url = generateLoginAndPayUrl(orderParams);
        window.location.href = url;
      }

      await createCheckout(orderParams);
    } finally {
      setInProgress(false);
    }
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <Button
            className={clsx(
              'w-full text-white flex items-center justify-between',
              'group',
              isEmptyCart && 'bg-[#D0D5DD] text-[#98A2B3]'
            )}
            onClick={handleCheckout}
            disabled={isInProgress || isEmptyCart}
          >
            <Flex.Row className="gap-2 items-center w-full justify-center">
              <span className="font-medium text-sm">
                {isInProgress ? 'Placing order' : 'Subscribe'}
              </span>
              {!isInProgress ? (
                <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-all" />
              ) : (
                <LoaderCircle className="w-4 h-4 animate-spin" />
              )}
            </Flex.Row>
          </Button>
        </TooltipTrigger>
        {isEmptyCart && (
          <TooltipContent>
            <p>You need to add products to the cart</p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
